(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.content-cell.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.content-cell.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const TableContentCell = _ref => {
  let children = _ref.children,
    className = _ref.className;
  return React.createElement("td", {
    className: clx('tipsinfo_table__content_cell', className)
  }, children);
};
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableContentCell', TableContentCell);

 })(window);